<template>
  <div class="tabbar width-100 flex-row justify-content-around align-items-center" style="z-index: 999">
    <div class="width-25 textAlign-c" @click="$router.replace('/home')">
      <van-image
        :src="active == 1 ? require('../assets/image/home/home-active.png') : require('../assets/image/home/home.png')"
        width="21px"
        height="21px"
      />
      <p :class="active == 1 ? 'reds fs-sml fm-sh-bold' : 'grey fs-sml fm-sh-regular'">首页</p>
    </div>
    <!-- <div class="width-25 textAlign-c" @click="$router.replace('/manuscriptIndex')">
      <van-image
        :src="active == 2 ? require('../assets/image/home/treasures-active.png') : require('../assets/image/home/treasures.png')"
        width="21px"
        height="21px"
      />
      <p :class="active == 2 ? 'reds fs-sml fm-sh-bold' : 'grey fs-sml fm-sh-regular'">夺宝</p>
    </div>
    <div class="width-25 textAlign-c" @click="$router.replace('/leaderboard')">
      <van-image
        :src="active == 3 ? require('../assets/image/home/leaderboard-active.png') : require('../assets/image/home/leaderboard.png')"
        width="21px"
        height="21px"
      />
      <p :class="active == 3 ? 'reds fs-sml fm-sh-bold' : 'grey fs-sml fm-sh-regular'">排行榜</p>
    </div> -->
    <div style="width: 1px; height: 2rem; background: #eeeeee"></div>
    <div class="width-25 textAlign-c" @click="$router.push('/prizeManagement')">
      <van-image
        :src="active == 4 ? require('../assets/image/home/setting-active.png') : require('../assets/image/home/setting.png')"
        width="21px"
        height="21px"
      />
      <p :class="active == 4 ? 'reds fs-sml fm-sh-bold' : 'grey fs-sml fm-sh-regular'">中奖记录</p>
    </div>
    <!-- <div v-if="$store.state.userInfo.is_visit_article == 1" class="width-25 textAlign-c" @click="$router.push('/zhishu')">
      <van-image
        :src="active == 5 ? require('../assets/image/home/zhishuActive.png') : require('../assets/image/home/zhishu.png')"
        width="21px"
        height="21px"
      />
      <p :class="active == 5 ? 'reds fs-sml fm-sh-bold' : 'grey fs-sml fm-sh-regular'">指数监测</p>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'INDEX',
  props: {
    active: String
  },
  data() {
    return {};
  },
  created() {
    // this.countDown(); // 倒计时
  },
  mounted() {
    console.log(this.$store.state.userInfo, 'userInfo');
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  background-size: cover;
  height: 80px;
  background: white;
}
.font-color-grey {
  color: #8ea7b2;
}
.font-color-blue {
  color: #db303c;
}
</style>
